import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Market } from './components/Market';
import { Audience } from './components/Audience';
import { Approach } from './components/Approach';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { LegalPage } from './pages/LegalPage';
function HomePage() {
  return <>
      <Navbar data-id="element-0" />
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <Services data-id="element-3" />
        <Market data-id="element-4" />
        <Audience data-id="element-5" />
        <Approach data-id="element-6" />
        <ContactForm data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
      <WhatsAppButton data-id="element-9" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <div className="min-h-screen flex flex-col w-full" data-id="element-11">
        <Routes data-id="element-12">
          <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
          <Route path="/legal" element={<LegalPage data-id="element-16" />} data-id="element-15" />
        </Routes>
      </div>
    </BrowserRouter>;
}